<template>
  <b-col lg="12">
    <b-card>
      <div>
        <b-container
          fluid class="text-center filter-area-container"
          v-b-toggle.collapse2
          @click="isCollapsed = !isCollapsed"
        >
          <b-row>
            <b-col cols="auto" class="mr-auto p-3"><h5>{{$t('filterArea.container.label')}}</h5></b-col>
            <b-col cols="auto" class="p-3">
              <i
                class="fa fa-lg"
                :class="filterIconClass"
              ></i>
            </b-col>
          </b-row>
        </b-container>
        <b-collapse id="collapse2">
          <b-card style="margin-bottom: 0;">
            <slot></slot>
            <b-container fluid class="bv-example-row">
              <b-row class="mt-3">
                <b-col sm="12">
                  <button
                    class="btn btn-success float-right padder"
                    @click="filterData()"
                  >
                    {{ $t('actions.filter') }}
                  </button>
                  <button
                    class="btn btn-primary float-right"
                    @click="resetData()"
                  >
                    {{ $t('actions.reset') }}
                  </button>
                </b-col>
              </b-row>
            </b-container>
          </b-card>
        </b-collapse>
      </div>
    </b-card>
  </b-col>
</template>

<script>

  export default {
    name: "FilterArea",
    data: () => {
      return {
        isCollapsed: false
      }
    },
    computed: {
      filterIconClass: function(){
        return this.isCollapsed ? 'fa-chevron-up' : 'fa-chevron-down'
      }
    },
    methods: {
      filterData(){
        this.$emit('filterData');
      },
      resetData(){
        this.$emit('resetData')
      }
    }
  }

</script>

<style scoped>
  i.fa{
    cursor:pointer;
    color: grey
  }
  i.fa:hover{
    color: #1f57a4
  }
  .filter-area-container{
    cursor:pointer
  }
</style>
